module.exports = __webpack_public_path__ + "static/img/onlineInfo.1ba136d1.jpg";